import { customEvent } from "goi_common";

import { ParlorHeader } from "@/containers/ParlorDetailContainer/components/ParlorHeader";

import { QuoteParlorInfo } from "./components/QuoteParlorInfo";
import { QuoteCtaBottom } from "./components/QuoteCtaBottom";
import { QuoteQuickEstimateSection } from "./components/QuoteQuickEstimateSection";
import { QuoteWhyDifferent } from "./components/QuoteWhyDifferent";
import { useParlorInquiryModal } from "@/hooks/useParlorInquiryModal";
import {
  UrgentCallBannerSection,
  useIsUrgentCallBannerShown,
} from "@/components/UrgentCallBannerExperiment";

interface QuoteLandingContainerProps {
  parlorId: number;
  parlorName: string;
  region: string;
  managedType: string;
  address: string;
  sidoCode: string;
  sigunguCode: string;
  costMubinso: number;
  costMin: number; // 만원 단위
  costMax: number;
}

/**
 * 네이버 검색광고 비즈채널용 견적 LP
 * - 도메인: parlor.goifuneral.co.kr (광고 노출 제한 키워드 우회)
 * - 페이지 자체에 실 콘텐츠 노출 (즉시 redirect 우회 정책)
 * - CTA 사용자 클릭으로 platform 매칭 페이지 이관
 *
 * 헤더: 기존 ParlorHeader 재사용 (다른 페이지와 동일)
 * 푸터: 글로벌 Layout의 Footer가 자동으로 붙음 → 자체 푸터 X
 */
export const QuoteLandingContainer = ({
  parlorId,
  parlorName,
  region,
  managedType,
  address,
  sidoCode,
  sigunguCode,
  costMubinso,
  costMin,
  costMax,
}: QuoteLandingContainerProps) => {
  const { openParlorInquiryModal } = useParlorInquiryModal("parlor_ad_quote");
  // now 콜 확대 실험 #360. B안은 맨 위 임종 배너를 띄우고 제목 옆 전화 버튼은 숨긴다(헤더 버튼은 둔다)
  const isUrgentBannerShown = useIsUrgentCallBannerShown();
  return (
    <>
      <ParlorHeader
        hidePhoneStrip
        showNav={false}
        showPhoneCta
        onPhoneCtaClick={() => {
          customEvent({
            newGtm: {
              path: "parlor_ad_quote",
              trigger_and_target: "btn_phone_header",
              properties: { parlor_id: parlorId, parlor_name: parlorName },
            },
          });
          void openParlorInquiryModal();
        }}
      />
      <main className="lp">
        {isUrgentBannerShown && (
          <UrgentCallBannerSection
            page="parlor_ad_quote"
            parlor={{ id: parlorId, name: parlorName }}
          />
        )}
        <QuoteParlorInfo
          parlorId={parlorId}
          parlorName={parlorName}
          hidePhoneCta={isUrgentBannerShown}
          region={region}
          managedType={managedType}
          address={address}
        />
        <QuoteQuickEstimateSection
          parlorId={parlorId}
          parlorName={parlorName}
          sidoCode={sidoCode}
          sigunguCode={sigunguCode}
          costMubinso={costMubinso}
          costFamily={costMin}
          costGeneral={costMax}
        />
        <div className="lp-divider" />
        <QuoteWhyDifferent>
          <QuoteCtaBottom parlorId={parlorId} parlorName={parlorName} />
        </QuoteWhyDifferent>
      </main>
    </>
  );
};
